import React from 'react';
import { Box } from '@mui/material';
import { Form } from '../components/form';

export function Communication({ defaultCommunicationMode = 'email' }) {
  return (
    <Box sx={{ display: 'flex', width: '100%', marginTop: '65px' }}>
      <Form api="COM" lockedCommunicationMode={defaultCommunicationMode} />
    </Box>
  );
}
